// 20 minutes
export const IDLE_TIME = 1_200_000;

// 5 minutes
export const IDLE_COUNTDOWN_TIME = 300_000;
